type Content = { id: number | string; totalLikes?: number; approved?: number };

const toNum = (v: any) => (v === null || v === undefined || v === '' ? -Infinity : +v);
const desc = (x: number, y: number) => (x > y ? -1 : x < y ? 1 : 0);
const ascId = (a: Content, b: Content) => String(a.id).localeCompare(String(b.id));

const compareLikes = (a: Content, b: Content) =>
  desc(toNum(a.totalLikes), toNum(b.totalLikes)) || ascId(a, b);

const compareApproved = (a: Content, b: Content) =>
  desc(toNum(a.approved), toNum(b.approved)) || ascId(a, b);

/** מיון טהור שמחזיר עותק ממוין ואינו משנה את המקור */
const sortContent = (content: Content[], method: 'approved' | 'likes' = 'likes'): Content[] => {
  const arr = [...content]; // לא לשנות מקור!
  return method === 'approved' ? arr.sort(compareApproved) : arr.sort(compareLikes);
};

export default sortContent;
